import{m as e}from"./chunk-HBP5N4FR.js";e();var t=`.dapp-core-component__pageStateStyles__wrapper {
  color: inherit;
}

.dapp-core-component__pageStateStyles__state {
  color: inherit;
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(t));var r={wrapper:"dapp-core-component__pageStateStyles__wrapper",state:"dapp-core-component__pageStateStyles__state"};export{t as a,r as b};
//# sourceMappingURL=chunk-Q644J7BS.js.map
